module.exports = __webpack_public_path__ + "img/week_card.092342ed.png";